import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hour',
    standalone: true
})
export class HourPipe implements PipeTransform {

  transform(value: number): string {
    const str = value.toString();
    if(str.length == 4) {
      const result = str.substring(0, 2) + ":" + str.substring(2, 4);
      return result;
    }else if(str.length == 3) {
      const result = str.substring(0, 1) + ":" + str.substring(1, 3);
      return result;
    }
    return str;
  }

}
